import { useState, useEffect } from 'react';
import { useList, useDebounce } from 'react-use';

import { countRead } from '../../firestoreReadCounter';

export default function useCollectionsSubscription (refs, dependencies = [], { initialItems = [] } = {}) {
  const [items, { set: setItems, updateAt }] = useList(initialItems ?? []);
  const [debouncedItems, setDebouncedItems] = useState(initialItems);
  useEffect(() => {
    if(!refs) return;

    const unsubscribes = refs.map((ref, refIndex) => {
      return ref.onSnapshot(({ docs }) => {
        countRead(docs[0]?.ref?.parent, docs.length);
        updateAt(refIndex, docs.map(_ => ({ id: _.id, ref: _.ref, ..._.data() })));
      });
    });
    return () => {
      unsubscribes.map(_ => _());
      setItems([]);
    };
  }, dependencies);
  useDebounce(() => {
    setDebouncedItems(items?.flat());
  }, 500, [items]);
  return debouncedItems;
};
